var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 0h23c3 0 4 1.898 4 3.797v48.406C31 54.102 30 56 27 56H4c-3 0-4-1.898-4-3.797V3.797C0 1.898 1 0 4 0z"}));
}

Phone.defaultProps = {"viewBox":"0 0 31 56"};

module.exports = Phone;

Phone.default = Phone;
